'use client'
import { debounce } from 'lodash'
import type { ChangeEvent, FC } from 'react'
import { useCallback, useState } from 'react'
import { searchTypes } from './types'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling } from '@/tools/o11y/client'
import { MagnifyingGlassIcon, SearchInput, SearchSize } from '@/tools/ui'

type Props = {
  searchType: string
}
export const UserSearchInput: FC<Props> = ({ searchType }) => {
  const { t } = useLocalisation()
  const { withErrorTracking } = useErrorHandling()

  const [searchInput, setSearchInput] = useState('')

  const debouncedSearch = debounce((value: string) => {
    setSearchInput(value)
  }, 500)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchInput = useCallback(
    withErrorTracking((e: ChangeEvent<HTMLInputElement>) => {
      debouncedSearch(e.target.value)
    }),
    []
  )

  const searchPlaceholder = () => {
    switch (searchType) {
      case searchTypes.CATEGORY:
        // TODO: check if category is restaurant and use key search.restaurants
        return t('search.general')
      case searchTypes.STORE:
        return t('collections.searchPlaceholder')
      default:
        return t('search.general')
    }
  }
  return (
    <SearchInput
      aria-label={t('store.navigation.search')}
      leadingIcon={MagnifyingGlassIcon}
      placeholder={searchPlaceholder()}
      size={SearchSize.small}
      value={searchInput}
      onChange={handleSearchInput}
    />
  )
}
